'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './smart-breadcrumbs.component';
import dynamic from 'next/dynamic';

const DynamicBreadcrumbsComponent: ComponentType<Props> = dynamic(
  () => import('./smart-breadcrumbs.component')
);

export default DynamicBreadcrumbsComponent;

export function calculateBreadcrumbsPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 12 },
    { sinceWidth: 768, height: 14 }
  ];

  return {
    heightSinceWidth
  };
}
